import React from 'react'

import Grid from '@material-ui/core/Grid'
import './index.scss'


import MessageMessagerie from '../../Component/MessageMessagerie'
import GestionDossier from '../../Component/GestionDossier'
import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      maxHeightWindow: this.props.client_id !== undefined && 25 || 0,
      uploadFileAction: [],
      anchorActionEl: {},
      messageConfiguration: [],
      dossier: {},
      scrollBodyPosition: 0,
      classeurExpended: {},
      dossiers: [],
      dossierId: undefined,
      actions: [],
      actionsConfigurations: {},
      recherche_message_messagerie: '',
      showMessageManagement: this.props.showMessageManagement !== false,
      dossierKey: Utils.getRandomNumber(),
      type_action_id: 30,
      reponse_to_action_id: undefined,
      newEmail: {},
    }
  }

  showMessageManagement = () => {
    this.setState({
      showMessageManagement: !this.state.showMessageManagement,
    }, this.scrollToBottom)
  }

  selectMessageMessagerie = (message) => {
    this.setState({
      selectedMessage: message
    })
  }

  render () {
    return (
      <Grid container style={{ margin: 0, padding: this.state.maxHeightWindow === 0 && 10 || 0 }} spacing={0}>

        {this.state.showMessageManagement && <Grid item xs={3} style={{ margin: 0, padding: 5, paddingRight: 15 }}>
          <MessageMessagerie selectMessageMessagerie={this.selectMessageMessagerie}
                             showMessageManagement={this.showMessageManagement}
                             maxHeightWindow={this.state.maxHeightWindow}/>
        </Grid>}
        <Grid item xs={this.state.showMessageManagement && 9 || 12}
              style={{
                margin: 0,
                padding: 0,
                //paddingTop: this.state.maxHeightWindow === 0 && 5,
                //paddingBottom: this.state.maxHeightWindow === 0 && 5
              }}>
          <GestionDossier
            contact_email={this.props.contact_email}
            contact_portable={this.props.contact_portable}
            handleDossier={this.props.handleDossier}
            dossier_status={this.props.dossier_status}
            showMessageManagementCb={this.showMessageManagement}
            showMessageManagement={this.state.showMessageManagement}
            client_id={this.props.client_id}
            preSelectedDossier={this.props.preSelectedDossier}
            preSelectedClasseur={this.props.preSelectedClasseur}
            preSelectedAction={this.props.preSelectedAction}
            maxHeightWindow={this.state.maxHeightWindow}
            message={this.state.selectedMessage || undefined}/>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/SDD/Page/Dashboard/index.js